module.exports = __webpack_public_path__ + "img/sales.bf741997.png";